// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"42707bcc","291":"d628c8de","453":"95032aff","667":"423f0f32","834":"b3a39c73","864":"72b6910c"}[chunkId] + ".chunk.js";
};